var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParticipantAdded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3821 21.0882C16.8291 21.0882 16.3821 20.6412 16.3821 20.0882V18.5382H14.8821C14.3291 18.5382 13.8821 18.0912 13.8821 17.5382C13.8821 16.9852 14.3291 16.5382 14.8821 16.5382H16.3821V14.9902C16.3821 14.4382 16.8291 13.9902 17.3821 13.9902C17.9351 13.9902 18.3821 14.4382 18.3821 14.9902V16.5382H19.8721C20.4251 16.5382 20.8721 16.9852 20.8721 17.5382C20.8721 18.0912 20.4251 18.5382 19.8721 18.5382H18.3821V20.0882C18.3821 20.6412 17.9351 21.0882 17.3821 21.0882Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7114 2.91211C8.10541 2.91211 5.99341 5.05611 5.99341 7.69811C5.99341 10.3421 8.10541 12.4841 10.7114 12.4841C13.3174 12.4841 15.4294 10.3421 15.4294 7.69811C15.4294 5.05611 13.3174 2.91211 10.7114 2.91211Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9747 13.8379H8.35171C5.68471 13.8379 3.42871 16.1269 3.42871 18.8319C3.42871 19.3359 3.42871 19.9369 3.52171 20.4459C3.52771 20.4799 3.52971 20.5149 3.53471 20.5479C3.56571 20.7379 3.76171 20.9129 4.04371 20.9129H9.76671C10.0847 20.9129 10.3707 20.7199 10.4887 20.4249L12.7017 14.9139C12.9087 14.3989 12.5297 13.8379 11.9747 13.8379Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantAdded);
export default __webpack_public_path__ + "static/media/PARTICIPANT_ADDED.2d433c07d979aa9e4eeff1401f5bc900.svg";
export { ForwardRef as ReactComponent };